import {
  FETCH_LANGUAGES,
  FETCH_LANGUAGES_SUCCESS,
  FETCH_LANGUAGES_FAILED,
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILED,
  FETCH_TEAMS,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_FAILED,
  FETCH_USER_LIST,
  FETCH_USER_LIST_SUCCESS,
  FETCH_USER_LIST_FAILED,
  INSERT_NEW_USER,
  INSERT_NEW_USER_SUCCESS,
  INSERT_NEW_USER_FAILED,
  UPDATE_USER_DETAILS,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAILED,
  FILE_UPLOAD,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAILED,
  FETCH_USER_TYPE,
  FETCH_USER_TYPE_SUCCESS,
  FETCH_USER_TYPE_FAILED,
  UPDATE_EXISTING_KEYWORD,
  UPDATE_EXISTING_KEYWORD_SUCCESS,
  UPDATE_EXISTING_KEYWORD_FAILED,
} from "./../constants/constants";

const initialState = {
  success: {
    message: "",
  },
  error: {
    message: "",
  },
  loading: true,
  update: false,
  insert: true,
  userList: [],
  userLanguages: [],
  userProducts: [],
  userTeams: [],
  userTypes: [],
  keywordsList: [],
};

const SuperAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LANGUAGES:
      return {
        ...state,
      };
    case FETCH_LANGUAGES_SUCCESS:
      return {
        ...state,
        userLanguages: action.data || [],
      };
    case FETCH_LANGUAGES_FAILED:
      return {
        ...state,
      };
    case FETCH_PRODUCTS:
      return {
        ...state,
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        userProducts: action.data || [],
      };
    case FETCH_PRODUCTS_FAILED:
      return {
        ...state,
      };
    case FETCH_TEAMS:
      return {
        ...state,
      };
    case FETCH_TEAMS_SUCCESS:
      return {
        ...state,
        userTeams: action.data || [],
      };
    case FETCH_TEAMS_FAILED:
      return {
        ...state,
      };
    case FETCH_USER_TYPE:
      return {
        ...state,
      };
    case FETCH_USER_TYPE_SUCCESS:
      return {
        ...state,
        userTypes: action.data || [],
      };
    case FETCH_USER_TYPE_FAILED:
      return {
        ...state,
      };
    case FETCH_USER_LIST:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case FETCH_USER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userList: action.data || [],
      };
    case FETCH_USER_LIST_FAILED:
      return {
        ...state,
      };

    case INSERT_NEW_USER:
      return {
        ...state,
        loading: true,
        insert: false,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case INSERT_NEW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        insert: true,
        success: {
          message: "New user has been created !!!",
        },
      };
    case INSERT_NEW_USER_FAILED:
      return {
        ...state,
        loading: false,
        insert: false,
        error: {
          message: action.data.Statusdesc,
        },
      };
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        loading: true,
        update: false,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        update: true,
        success: {
          message: "User details has been updated !!!",
        },
      };
    case UPDATE_USER_DETAILS_FAILED:
      return {
        ...state,
        error: {
          message: "Unable to update user details",
        },
      };
    case FILE_UPLOAD:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          message: "File has been uploaded !!!",
        },
        keywordsList: action.data.data || [],
      };
    case FILE_UPLOAD_FAILED:
      return {
        ...state,
        error: {
          message: "Unable to upload file",
        },
      };
    case UPDATE_EXISTING_KEYWORD:
      return {
        ...state,
        loading: true,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
    case UPDATE_EXISTING_KEYWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: {
          message: "Keywords details has been updated !!!",
        },
        keywordsList: [],
      };
    case UPDATE_EXISTING_KEYWORD_FAILED:
      return {
        ...state,
        error: {
          message: "Unable to update keywords details",
        },
      };
    default:
      return state;
  }
};
export default SuperAdminReducer;
